import { render, staticRenderFns } from "./DetailVideoSection.vue?vue&type=template&id=ca5b00d2"
import script from "./DetailVideoSection.vue?vue&type=script&lang=js"
export * from "./DetailVideoSection.vue?vue&type=script&lang=js"
import style0 from "./DetailVideoSection.vue?vue&type=style&index=0&id=ca5b00d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('/app/nuxt/components/Video.vue').default})
